import React from 'react';

export const LinkBox = ({ title, link, className, file }) => {
  return (
    <>
      {file ? (
        <a target="_blank" rel="noopener noreferrer" href={link} download>
          <div
            className={`link-box d-flex align-items-center justify-content-around ${className}`}
          >
            <h5 className="ml-3">{title}</h5>
          </div>
        </a>
      ) : (
        <a target="_blank" rel="noopener noreferrer" href={link}>
          <div
            className={`link-box d-flex align-items-center justify-content-around ${className}`}
          >
            <h5 className="ml-3">{title}</h5>
          </div>
        </a>
      )}
    </>
  );
};

export default LinkBox;
